/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RepairOnCenterDeliveryCreateDto } from '../../models/repair-on-center-delivery-create-dto';

export interface DeliveryControllerCreateRepairOnCenterDelivery$Params {
      body: RepairOnCenterDeliveryCreateDto
}

export function deliveryControllerCreateRepairOnCenterDelivery(http: HttpClient, rootUrl: string, params: DeliveryControllerCreateRepairOnCenterDelivery$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deliveryControllerCreateRepairOnCenterDelivery.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deliveryControllerCreateRepairOnCenterDelivery.PATH = '/delivery/repair-on-center';
